// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legal{position:relative;display:block;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;font-size:.75em;line-height:100%;margin:0;padding:.5em 0 0 0;max-width:30em;text-align:left;color:#818181}", ""]);
// Exports
module.exports = exports;
